<template>
  <div class="rnd-bottom w-full" @mouseover.stop @click.stop>

    <!-- Notes -->
    <itemScroll>
      <div class="col gap-30 w-full">
        <template v-for="noteGroup in allPatientNoteGroups" :key="noteGroup.keyword">
          <template v-if="[NoteGroup.NOTES, NoteGroup.MISSIONS].includes(noteGroup.keyword) || noteGroup.tasks.length">
            <div class="w-full">
              <!-- Title -->
              <div class="row">
                <text-item :txt="getNoteGroupLabel(noteGroup.keyword)" class="h4 mleft-05 pad-m"/>
                <button-group v-if="(noteGroup.keyword === NoteGroup.VALIDATED)" @click="showValidated = !showValidated">
                  <svg-item :icon="showValidated ? 'chevronDown' : 'chevronsUp'" styles="size-l main-l"/>
                </button-group>
                <!-- Add note -->
                <div v-if="pwrPatient && [NoteGroup.NOTES, NoteGroup.MISSIONS].includes(noteGroup.keyword)">
                  <itemModal :uiId="'addTaskNote' + noteGroup.keyword">
                    <buttonGroup styles="pad-m">
                      <svg-item icon="plus" styles="size-l main-l"/>
                    </buttonGroup>
                    <template #modal>
                      <div class="item-modal">
                        <editTask v-if="noteGroup.keyword === NoteGroup.NOTES" :pwrPatient="pwrPatient" :canChangePatient="false" startTaskBox="Healthcare" @changed="reload()"/>
                        <editTask v-else-if="noteGroup.keyword === NoteGroup.MISSIONS" :pwrPatient="pwrPatient" :canChangePatient="false" @changed="reload()"/>
                      </div>
                    </template>
                  </itemModal>
                </div>
              </div>

              <!-- Tasks -->
              <template v-if="!(noteGroup.keyword === NoteGroup.VALIDATED && !showValidated)">
                <template v-for="task in noteGroup.tasks" :key="task.taskId">
                  <div class="t-rowLine mleft-10">
                  </div>
                  <taskCard :task="task" :showPatient="false" :isTransparent="true" @changed="reload()"/>
                </template>
              </template>
              <div class="t-rowLine mleft-10"></div>
            </div>
          </template>
        </template>
      </div>
    </itemScroll>

  </div>
</template>



<script setup>
import taskCard from "@/views/officeMain/tasks/taskCard.vue"
import editTask from "@/views/officeMain/tasks/editTask.vue"

import { ref, computed } from 'vue'
import { useCurrentEntryStore } from '@/stores/currentEntry.ts'
import { NoteGroup, getNoteGroupLabel } from '@/functions/office';

const currentEntryStore = useCurrentEntryStore()

const showValidated = ref(false);
const allPatientNoteGroups = computed(() => {
  return currentEntryStore.modalPatientNotes
})

const pwrPatient = computed(() => {
  return currentEntryStore.modalPatient || null
})


function reload() {
  currentEntryStore.reloadModalPatientNotes(currentEntryStore.modalPatient.personWithRoleId);
}


</script>

<style scoped>
.custom-box {
  padding: 0.5rem 1rem 1rem 1.4rem;
  cursor: auto;
}
</style>